import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Award, Users, Download, Leaf } from 'lucide-react';
import { companyInfo } from '../mockData';

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToQuote = () => {
    document.getElementById('quote-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToProjects = () => {
    document.getElementById('projects-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero-section" aria-label="Hero - Green Art Landscape">
      <div className="hero-background">
        <div 
          className="hero-image-layer"
          style={{ transform: `translateY(${scrollY * 0.5}px)` }}
        >
          <img
            src="https://images.unsplash.com/photo-1558904541-efa843a96f01?w=1920&h=1080&fit=crop"
            alt="Lush green landscaping by Green Art in Abu Dhabi"
            className="hero-image"
            loading="eager"
          />
        </div>
        <div className="hero-overlay"></div>
        <div className="hero-organic-shape shape-1"></div>
        <div className="hero-organic-shape shape-2"></div>
      </div>

      <div className="hero-content">
        <div className="hero-logo-large">
          <img 
            src="https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/6rf6onic_885ea933-b00e-4489-80dc-ff243e4d3458-removebg-preview.png" 
            alt="GREEN ART LANDSCAPE & GARDENING SERVICES L.L.C. - Abu Dhabi landscaping company logo" 
            className="hero-logo-image"
          />
        </div>
        
        <p className="hero-subtitle" role="heading" aria-level="1">
          More Green in Every Scene
        </p>

        <div className="hero-stats">
          <div className="stat-card">
            <Award className="stat-icon" />
            <div className="stat-content">
              <div className="stat-number">4</div>
              <div className="stat-label">ISO Certifications</div>
            </div>
          </div>
          
          <div className="stat-card">
            <Users className="stat-icon" />
            <div className="stat-content">
              <div className="stat-number">15+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
          </div>
        </div>

        <div className="hero-actions">
          <Button 
            onClick={scrollToQuote}
            className="btn-primary btn-3d"
            size="lg"
          >
            Get A Quote
          </Button>
          <Button 
            onClick={scrollToProjects}
            variant="outline" 
            className="btn-secondary btn-3d"
            size="lg"
          >
            View Projects
          </Button>
          <a 
            href="https://customer-assets.emergentagent.com/job_portfolio-pro-505/artifacts/l1h5scva_GREEN%20ART%20LANDSCAPE%20COMPANY%20PROFILE%202026_compressed%20%281%29.pdf"
            download="Green-Art-Company-Profile-2026.pdf"
            className="btn-download-hero"
          >
            <Button 
              variant="outline" 
              className="btn-secondary btn-3d"
              size="lg"
            >
              <Download className="w-5 h-5" />
              Download Profile
            </Button>
          </a>
        </div>
      </div>

      <div className="hero-scroll-indicator">
        <div className="scroll-line"></div>
        <span>Scroll to explore</span>
      </div>
    </section>
  );
};

export default Hero;
